import client from './client';

export const formsApi = {
  /** Renvoie les formulaires actifs avec leurs champs (utilisé pour construire les forms du front) */
  list: () => client.get('/forms', { auth: false }),
};
